import React, { ReactNode } from "react";
import styles from "./CenterContent.module.css";

interface Props {
  children: ReactNode;
}

export const CenterContent: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {
  return <div className={styles.center}>{children}</div>;
};
